import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {handleLogin} from '../redux/authentication'
import {refreshAccess, clearLogin} from '../utility/adminSessionClient'
import AdminSession from './AdminSession'
import ability from '../configs/acl/ability'
export default function AdminSessionBootstrap({children}) {
 const dispatch = useDispatch(), [ready, setReady] = useState(false), [error, setError] = useState(false), [version, setVersion] = useState(0)
 useEffect(() => {
  let active = true
  refreshAccess().then(r => { if (active) { const rules = [{action:'manage', subject:'all'}]; ability.update(rules); dispatch(handleLogin({...r.userInfo, accessToken:r.accessToken, ability:rules})) } }).catch(e => {
   if (e.response?.status === 401) clearLogin()
   else if (active) setError(true)
  }).finally(() => { if (active) setReady(true) })
  return () => { active = false }
 }, [version])
 if (error) return <main className="staff-panel" role="alert"><p>로그인 상태를 확인하지 못했습니다.</p><button onClick={() => { setError(false); setReady(false); setVersion(v => v + 1) }}>다시 시도</button></main>
 if (!ready) return <p role="status" style={{padding:32}}>로그인 상태를 확인하는 중입니다…</p>
 return <><AdminSession/>{children}</>
}
